import mainComponent from '@/layouts/main/Main.vue'

export default [{
  path: '/relatorios',
  component: mainComponent,
  title: 'Relatórios',
  children: [{
      path: 'estoque',
      name: 'report-stock',
      component: () => import('@/views/report/stock/StockReport.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Relatórios' },
          { title: 'Estoque', active: true },
        ],
        pageTitle: 'Relatório de Estoque',
        rule: 'editor'
      },
    },
    {
      path: 'vendas',
      name: 'report-sale',
      component: () => import('@/views/report/sale/SaleReport.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Relatórios' },
          { title: 'Vendas', active: true },
        ],
        pageTitle: 'Relatório de Vendas',
        rule: 'editor'
      },
    }
  ],
}, ];